// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import i18n from "../i18n";

// initialize an empty api service that we'll inject endpoints into later as needed
export const inbusSplitApi = createApi({
  reducerPath: "inbusApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/rest",
    prepareHeaders: (headers) => {
      headers.set("Accept-Language", i18n.language);
      return headers;
    },
  }),
  endpoints: () => ({}),
});
